import React from "react";
import "./inputs-pdf-form-template.css";

const InputsPDFFormPure = (props) => {
  const { messageBtn } = props;

  return (
    <div className="input-file-style">
      <i
        className="k-icon k-i-plus InputsPDFFormPure-plus-icon"
        style={{ fontSize: "20px" }}
      ></i>
      <input
        className="input-files"
        type="file"
        accept="application/pdf"
        id="file"
        {...props}
      />
      {messageBtn}
    </div>
  );
};

export { InputsPDFFormPure as default };
